var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.software.ativo ? 'card card-active' : 'card'},[_c('div',{staticClass:"row text-center"},[_c('div',{staticClass:"col-12 text-center"},[_c('v-img',{attrs:{"src":_vm.software.icone,"height":"150px","width":"100%","alt":_vm.software.nome}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }